import React, { Component } from "react";
import PropTypes from "prop-types";

import { noop } from "../../utils";
import { saveNodeType, isHover } from "../utils";

import OrderInteractiveModular from "../components/OrderInteractiveModular";

class EachOrderInteractive extends Component {
  constructor(props) {
    super(props);

    this.handleHover = this.handleHover.bind(this);
    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.isHover = isHover.bind(this);
    this.saveNodeType = saveNodeType.bind(this);
    this.nodes = {};

    this.state = {
      hover: false,
    };
  }

  handleDragStart(moreProps) {
    const { order } = this.props;
    const { price } = order;
    const { mouseXY } = moreProps;
    const {
      chartConfig: { yScale },
    } = moreProps;
    const [, mouseY] = mouseXY;

    const dy = mouseY - yScale(price);

    this.dragStartPosition = {
      price,
      dy,
    };
  }

  handleDrag(newPrice) {
    const { index, onDrag } = this.props;

    // Allow dragging both local and open orders
    // (handleDragComplete will determine the appropriate action)

    // Call the parent's onDrag with index and newPrice
    if (onDrag) {
      onDrag(index, newPrice);
    }
  }

  handleHover(moreProps) {
    if (this.state.hover !== moreProps.hovering) {
      this.setState({
        hover: moreProps.hovering,
      });
    }
  }

  handleClick(moreProps) {
    const { index, onDelete, onSubmit, order } = this.props;

    // Get hover type from the base component
    const hoverType =
      this.nodes.orderLine && this.nodes.orderLine.isHover
        ? this.nodes.orderLine.isHover(moreProps)
        : false;

    if (hoverType === "trash") {
      // Handle delete action
      if (onDelete) {
        onDelete(index, moreProps);
      }
    } else if (hoverType === "send" && order.state === "local") {
      // Handle submit action for local orders
      if (onSubmit) {
        onSubmit(index, moreProps);
      }
    }
  }

  handleDoubleClick(moreProps) {
    const { index, onSubmit, order } = this.props;

    // Only allow submitting local orders
    if (order.state === "local" && onSubmit) {
      onSubmit(index, moreProps);
    }
  }

  handleDoubleClickForOrderLine(moreProps) {
    // Pass double click to OrderLine for quantity editing
    if (this.nodes.orderLine && this.nodes.orderLine.handleDoubleClick) {
      this.nodes.orderLine.handleDoubleClick(moreProps);
    }
  }

  render() {
    const {
      index,
      order,
      selected,
      onDragComplete,
      draggable,
      offset = 0,
      allOrders = [],
    } = this.props;
    const { hover } = this.state;

    const hoverHandler = {
      onHover: this.handleHover,
      onUnHover: this.handleHover,
    };

    const dragProps =
      draggable && (order.state === "local" || order.state === "open")
        ? {
            onDragStart: (moreProps) => {
              this.handleDragStart(moreProps);
              if (this.props.onDragStart)
                this.props.onDragStart(index, moreProps);
            },
            onDrag: this.handleDrag,
            onDragComplete: onDragComplete,
          }
        : {};

    return (
      <g>
        <OrderInteractiveModular
          ref={this.saveNodeType("orderLine")}
          index={index}
          order={order}
          selected={selected}
          hovering={hover}
          offset={offset}
          allOrders={allOrders}
          onClick={this.handleClick}
          onSubmit={this.props.onSubmit}
          onDelete={this.props.onDelete}
          onQuantityEdit={this.props.onQuantityEdit}
          onStopsClick={this.props.onStopsClick}
          onOTORemove={this.props.onOTORemove}
          onOTOEdit={this.props.onOTOEdit}
          onDoubleClick={this.handleDoubleClickForOrderLine}
          tempOTOPrices={this.props.tempOTOPrices}
          {...hoverHandler}
          {...dragProps}
          data-evo-id="interactive-wrapper-order-interactive"
        />
      </g>
    );
  }
}

EachOrderInteractive.propTypes = {
  index: PropTypes.number,
  order: PropTypes.shape({
    id: PropTypes.string.isRequired,
    state: PropTypes.oneOf([
      "local",
      "pending",
      "open",
      "filled",
      "cancelled",
      "rejected",
    ]).isRequired,
    side: PropTypes.oneOf(["buy", "sell"]).isRequired,
    price: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired,
    symbol: PropTypes.string.isRequired,
  }).isRequired,

  draggable: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  offset: PropTypes.number,
  allOrders: PropTypes.array,

  onDrag: PropTypes.func.isRequired,
  onDragComplete: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
  onQuantityEdit: PropTypes.func,
  onStopsClick: PropTypes.func,
  onDragStart: PropTypes.func,
  onOTORemove: PropTypes.func,
  onOTOEdit: PropTypes.func,
  tempOTOPrices: PropTypes.object, // Map containing temporary OTO prices during drag
};

EachOrderInteractive.defaultProps = {
  onDrag: noop,
  onDragComplete: noop,
  onSubmit: noop,
  onDelete: noop,
  onQuantityEdit: noop,
  onStopsClick: noop,
  onOTORemove: noop,
  onDragStart: noop,
  tempOTOPrices: null,
  selected: false,
  draggable: true,
};

export default EachOrderInteractive;
